/* RESPONSIBLE TEAM: team-phone */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class CallingSerializer extends EmbercomBaseSerializer {
  serializeAttribute(snapshot: any, json: any, key: string, attribute: any) {
    // Only serialize attributes that have been modified since last save/load.
    // This prevents stale values from one browser tab overwriting
    // changes made in another tab (last-write-wins race condition).
    // See: https://github.com/intercom/intercom/issues/411836
    if (key in snapshot.changedAttributes()) {
      super.serializeAttribute(snapshot, json, key, attribute);
    }
  }
}
